import React from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import Request from '../../../services/request';
import SweetAlert from '../../../services/sweetAlert';
import Notifications from '../../../services/notifications';
import * as Utils from '../../../services/utilityFunctions';
import translate from '../../../commonComponents/translate';
import withCSRF from '../../../commonComponents/withCSRF';
import List from '../../../commonComponents/lists/List';
import BooleanColumn from '../../../commonComponents/lists/columns/BooleanColumn';

function SubscriptionList({ t, query, _csrf }) {
  const tableId = 'subscriptionList';

  const cancelSubscription = reason => {
    try {
      new Request(_csrf)
        .delete('/subscription', { reason })
        .done(() => {
          SweetAlert.success({
            title: t('subscription_cancel_successful_title'),
            text: t('subscription_cancel_successful_msg'),
          }).then(() => {
            window.location.href = '/';
          });
        })
        .fail(err => {
          let error = t('error_subscriptionCancel');
          if (err && err.responseJSON) {
            error = err.responseJSON.message || t(err.responseJSON.error);
          }
          Notifications.showNotificationError(t('error'), error);
        });
    } catch (err) {
      Notifications.showNotificationError(t('error'), err);
    }
  };

  const onClickCancelSubscription = () => {
    SweetAlert.warning({
      title: t('subscription_cancel_title'),
      text: t('subscription_cancel_msg'),
      input: 'textarea',
      inputPlaceholder: t('subscription_cancel_reason_placeholder'),
      inputValidator: value =>
        !value && t('subscription_cancel_reason_required'),
      width: '50%',
      position: 'top',
      showConfirmButton: true,
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonText: t('subscription_cancel_button'),
      cancelButtonText: t('cancel'),
      confirmButtonClass: 'btn btn-danger m-btn m-btn--wide',
      preConfirm: () => {},
    }).then(result => {
      if (result.value) {
        cancelSubscription(result.value);
      }
    });
  };

  function handleListInitialization() {
    $(`#${tableId}`).on('click', '.cancel-button', onClickCancelSubscription);
  }

  const columns = [
    {
      field: 'type',
      title: t('subscription_type'),
      textAlign: 'center',
      sortable: false,
    },
    {
      field: 'startDate',
      title: t('subscription_startDate'),
      textAlign: 'center',
      sortable: false,
    },
    {
      field: 'expirationDate',
      title: t('subscription_expirationDate'),
      textAlign: 'center',
      sortable: false,
    },
    {
      field: 'subscriptionPaymentStatus',
      title: t('subscription_subscriptionPaymentStatus'),
      textAlign: 'center',
      sortable: false,
    },
    {
      field: 'isActive',
      title: t('subscription_isActive'),
      template: ({ isActive, awaitingValidation }) =>
        renderToStaticMarkup(
          <BooleanColumn value={isActive && !awaitingValidation} />,
        ),
      textAlign: 'center',
      sortable: false,
    },
    {
      field: 'cancellationDate',
      title: t('subscription_cancellationDate'),
      textAlign: 'center',
      sortable: false,
    },
  ];

  const dataTransform = subscription => ({
    ...subscription,
    startDate: Utils.displayDate(subscription.startDate) || '- -',
    expirationDate: Utils.displayDate(subscription.expirationDate) || '- -',
    cancellationDate: Utils.displayDate(subscription.cancellationDate) || '- -',
    type: subscription.type ? t(`subscription_type_${subscription.type}`) : '',
    originalType: subscription.type,
    subscriptionPaymentStatus: subscription.subscriptionPaymentStatus
      ? t(`subscription_status_${subscription.subscriptionPaymentStatus}`)
      : '- -',
  });

  return (
    <List
      id={tableId}
      query={query}
      dataSourceURL="/subscription/list"
      columns={columns}
      dataTransform={dataTransform}
      onInit={handleListInitialization}
    />
  );
}

SubscriptionList.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  query: PropTypes.shape({}).isRequired,
};

export default Utils.compose(translate, withCSRF)(SubscriptionList);
